import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {FormattedMessage, injectIntl} from 'react-intl';
import classNames from 'classnames';
import ImageLazy from '../ImageLazy';
import {Button} from '@mui/material';
import bannerImg from '../../assets/images/defaultImages/banner.jpg';
import './EventSection.scss';
import {ArrowForward, ArrowRight} from "@mui/icons-material";

const EventSection = props => {
  const event = props.eventDetails;
  const imageUrl = event.images.side_banner || bannerImg;

  const classes = classNames('event', {
    [`event--${event.id}`]: event,
  });

  const mainPage = () => {
    const hideLobby = [
      '841b7b82-f152-470b-88df-c9cd4deab0c1',
      'e9795940-d1bc-419c-ac4e-22ff2e806f37',
      'c47ea34f-e868-4ade-8745-d0ccc6180b85',
      '05ffd47e-b4db-4f54-b0b6-a55d0605bbe7',
      '54b237f9-6bc3-42fc-800e-a2d46eace54e',
      'abfdae24-05e1-470b-a032-93987d36d3a9',
      '79afb04c-9463-413e-a8dd-9e87fbdff66f',
      '5ec0f6a2-ab85-4cb7-9c49-b27af7fc43c7',
    ];

    if (hideLobby.includes(event.id)) {
      return 'attendees';
    }
    const hideLobbyAndAttendees = ['21e15529-927a-41f7-8ead-02ea01b92309'];

    if (hideLobbyAndAttendees.includes(event.id)) {
      return 'sessions';
    }
    return event.indexPagePath;
  };

  return (
    <Link to={`/event/${event.id}/${mainPage()}`} className={classes}>
      <div className="event__banner">
        <ImageLazy src={imageUrl} errorSrc={bannerImg} alt={event.name} width={366} height={183} />
      </div>
      <div className="event__info">
        <h3 className="event__title">{event.name}</h3>
        {/*
        {!event.isFinished ? <p className="event__label-live">Live</p> : null}
        */}
        <div className="event__date">{event.fullDateStrInEventTime}</div>
        <Button variant={'outlined'} color={"primary"} className="event__btn" endIcon={<ArrowForward />}>
          {event.isFinished ? (
            <FormattedMessage id="event.section.open.btn" />
          ) : (
            <FormattedMessage id="event.section.join.btn" />
          )}

        </Button>
      </div>
    </Link>
  );
};

EventSection.propTypes = {
  eventDetails: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default injectIntl(EventSection);
